export const YES = "Si";
export const NO = "No";
export const OK = "Ok";
